module.exports = __webpack_public_path__ + "static/media/solutions-grid-3.384bd1b3.webp";